import * as React from 'react';
import { SVGProps } from 'react';

const IconAddSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 2h-2v9H2v2h9v9h2v-9h9v-2h-9V2z" />
  </svg>
);
export default IconAddSizeM;
